import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.regexp.split.js";
import "core-js/modules/es6.map.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.array.find-index.js";
var Modal = function Modal() {
  return import('@/components/organisms/Modal');
};
var PrimeIcon = function PrimeIcon() {
  return import('@/components/atoms/PrimeIcon');
};
var SubmitButton = function SubmitButton() {
  return import('@/components/atoms/SubmitButton');
};
var AssetImage = function AssetImage() {
  return import('@/components/atoms/AssetImage');
};
var PartySlider = function PartySlider() {
  return import('@/components/molecules/PartySlider');
};
var DropSphere = function DropSphere() {
  return import('@/components/molecules/DropSphere');
};
var QuestEnemy = function QuestEnemy() {
  return import('@/components/molecules/QuestEnemy');
};
import Nl2br from 'vue-nl2br';
var RecoveryStaminaModal = function RecoveryStaminaModal() {
  return import('@/components/organisms/RecoveryStaminaModal');
};
export default {
  components: {
    Modal: Modal,
    PrimeIcon: PrimeIcon,
    SubmitButton: SubmitButton,
    AssetImage: AssetImage,
    PartySlider: PartySlider,
    DropSphere: DropSphere,
    QuestEnemy: QuestEnemy,
    Nl2br: Nl2br,
    RecoveryStaminaModal: RecoveryStaminaModal
  },
  props: {
    node: {
      type: Object,
      default: function _default() {},
      required: true
    },
    prevNodeId: {
      type: Number,
      default: 0,
      required: true
    },
    prevSelectedPartryNo: {
      type: Number,
      default: 0
    },
    isNormalQuest: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    }
  },
  data: function data() {
    var _this = this;
    return {
      selectedNodeId: 0,
      selectedTeam: 0,
      fee: 0,
      levelSwiperOption: {
        slidesPerView: 1,
        centeredSlides: true,
        spaceBetween: 8,
        breakpointsInverse: true,
        breakpoints: {
          768: {
            slidesPerView: 6,
            centeredSlides: false,
            spaceBetween: 16
          }
        },
        on: {
          init: function init() {
            return _this.levelSwiperInit();
          },
          slideChange: function slideChange() {
            _this.selectedNodeId = _this.getNodeIdByIndex(_this.levelSwiper.activeIndex);
          }
        }
      },
      teamSwiperOption: {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 8,
        breakpointsInverse: true,
        breakpoints: {
          768: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 16,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev'
            }
          }
        },
        on: {
          init: function init() {
            return _this.teamSwiperInit();
          },
          slideChange: function slideChange() {
            if (window.innerWidth > 768) {
              if (_this.teamSwiper.activeIndex <= _this.selectedTeam && _this.selectedTeam <= _this.teamSwiper.activeIndex + 2) {
                return;
              }
            }
            _this.selectedTeam = _this.teamSwiper.activeIndex;
          }
        }
      },
      questLevel: 0,
      isRepSphereLimtModalShow: false,
      isShowOriginal: true,
      isShowReplica: false,
      ingotLimit: false,
      isRecoveryStaminaModalShown: false,
      isPrimeErrorModalShown: false,
      orbLimit: false
    };
  },
  computed: {
    myOwnIds: function myOwnIds() {
      return useExtensionStore().myOwnIds;
    },
    getHero: function getHero() {
      return useHeroStore().getHero;
    },
    getExtension: function getExtension() {
      return useExtensionStore().getExtension;
    },
    templates: function templates() {
      return useDeckTemplateStore().getDeckTemplates;
    },
    me: function me() {
      return useUserStore().me;
    },
    quest: function quest() {
      return useNodeStore().getQuest;
    },
    isPrime: function isPrime() {
      return usePrimeStore().isPrime;
    },
    isDepartureModalShown: function isDepartureModalShown() {
      return !!Object.keys(this.node).length;
    },
    minLvNodeId: function minLvNodeId() {
      if (!this.isDepartureModalShown) {
        return 0;
      }
      var minLv = Math.min.apply(Math, _toConsumableArray(this.node.nodeLvsList.map(function (lv) {
        return lv.lv;
      })));
      return this.node.nodeLvsList.find(function (lv) {
        return lv.lv === minLv;
      }).nodeId;
    },
    lvs: function lvs() {
      var lvs = this.$util.clone(this.node.nodeLvsList);
      lvs.sort(function (p, c) {
        if (p.lv < c.lv) return -1;
        if (p.lv > c.lv) return 1;
        return 0;
      });
      return lvs;
    },
    selectedNode: function selectedNode() {
      var _this2 = this;
      return this.lvs.find(function (l) {
        return l.nodeId === _this2.selectedNodeId;
      }) || {};
    },
    prevNodeInfo: function prevNodeInfo() {
      return this.$localStorage.get('prevNodeInfo') || {};
    },
    isPrimeOnlyDisabled: function isPrimeOnlyDisabled() {
      return this.selectLvIsPrima && !this.isPrime;
    },
    isPrimeDisabled: function isPrimeDisabled() {
      return !this.isPrime && this.selectedTeam >= 3 && this.selectedTeam <= 9;
    },
    avairableHeroes: function avairableHeroes() {
      return this.$heroesService.getAvairableOriginalsStr(this.selectedNode.bannedRarity.heroRaritiesList).join(' / ');
    },
    avairableReplicaHeroes: function avairableReplicaHeroes() {
      return this.$heroesService.getAvairableReplicasStr(this.selectedNode.bannedRarity.replicaHeroRaritiesList).join(' / ');
    },
    avairableTotalHeroes: function avairableTotalHeroes() {
      return [this.avairableHeroes, this.avairableReplicaHeroes].join(' / ');
    },
    avairableExtensions: function avairableExtensions() {
      return this.$extensionsService.getAvairableOriginalsStr(this.selectedNode.bannedRarity.originalExtensionRaritiesList).join(' / ');
    },
    avairableReplicaExtensions: function avairableReplicaExtensions() {
      return this.$extensionsService.getAvairableReplicasStr(this.selectedNode.bannedRarity.replicaExtensionRaritiesList).join(' / ');
    },
    avairableTotalExtensions: function avairableTotalExtensions() {
      return [this.avairableExtensions, this.avairableReplicaExtensions].join(' / ');
    },
    isRecoveryStaminaBtnShown: function isRecoveryStaminaBtnShown() {
      return this.selectedNodeId && this.isPossibleStamina && !this.isPossiblePartyLv && !this.isPrimeOnlyDisabled && !this.isPrimeDisabled && !this.isNotSector && !this.isQuestLimit && this.isNormalQuest;
    },
    cannotGo: function cannotGo() {
      return !this.selectedNodeId || this.isPossibleStamina || this.isPossiblePartyLv || this.isPrimeOnlyDisabled || this.isPrimeDisabled || this.isNotSector || this.isQuestLimit;
    },
    isPossibleStamina: function isPossibleStamina() {
      return this.lvs[this.questLevel].stamina > useUserStore().getStamina.currentStamina && this.isNormalQuest;
    },
    isPossiblePartyLv: function isPossiblePartyLv() {
      return this.partyLv > this.getPartyLv(this.templates[this.selectedTeam]);
    },
    isNotSector: function isNotSector() {
      var lv = this.lvs[this.questLevel];
      return !this.isNormalQuest && lv.maxCnt == 0;
    },
    isQuestLimit: function isQuestLimit() {
      var lv = this.lvs[this.questLevel];
      return !this.isNormalQuest && lv.maxCnt - lv.currentCnt <= 0;
    },
    selectLvIsPrima: function selectLvIsPrima() {
      if (this.lvs[this.questLevel].isPrime) return true;
      return false;
    },
    partyLv: function partyLv() {
      return this.lvs[this.questLevel].partyLevel;
    },
    getStory: function getStory() {
      var str = this.node.description[this.$i18n.locale].split('<br>');
      str.join('\n');
      return str.join('\n');
    },
    drops: function drops() {
      if (!this.node.dropExtensionTypeMap.size) {
        return new Map();
      }
      return this.node.dropExtensionTypeMap;
    },
    getDropType: function getDropType() {
      if (!this.isNormalQuest) {
        return 'land';
      }
      return 'node';
    },
    getLandMaxQuestCount: function getLandMaxQuestCount() {
      return this.selectedNode.maxCnt;
    },
    getLandCurrentQuestCount: function getLandCurrentQuestCount() {
      return this.selectedNode.maxCnt - this.selectedNode.currentCnt;
    }
  },
  watch: {
    node: {
      handler: function handler() {
        if (!this.isDepartureModalShown) return;
        this.init();
      },
      deep: true
    }
  },
  beforeMount: function beforeMount() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return useDeckTemplateStore().fetchDeckTemplates();
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    fetchMyOwnExtensionIds: function fetchMyOwnExtensionIds() {
      return useExtensionStore().fetchMyOwnExtensionIds();
    },
    fetchExtensions: function fetchExtensions(arg) {
      return useExtensionStore().fetchExtensions(arg);
    },
    init: function init() {
      this.selectedNodeId = this.prevNodeId || this.minLvNodeId;
      for (var i = 0; i < this.lvs.length; i++) {
        if (this.lvs[i].nodeId == this.selectedNodeId) {
          this.questLevel = i;
          break;
        }
      }
      this.selectedTeam = useNodeStore().getCurrentDeckNo;
    },
    fetchMyOwnData: function fetchMyOwnData() {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return useDeckTemplateStore().fetchDeckTemplates();
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    getIsSameNode: function getIsSameNode(nodeId) {
      return this.node.nodeLvsList.some(function (lv) {
        return lv.nodeId === nodeId;
      });
    },
    getIsUnavailableHero: function getIsUnavailableHero(heroId) {
      var hero = this.getHero(heroId);
      if (this.isReplicaHero(hero)) {
        return this.selectedNode.bannedRarity.replicaHeroRaritiesList.includes(hero.rarity);
      } else {
        return this.selectedNode.bannedRarity.heroRaritiesList.includes(hero.rarity);
      }
    },
    getIsUnavailableExtension: function getIsUnavailableExtension(extensionId) {
      var ext = this.getExtension(extensionId);
      if (ext.asset) {
        return this.selectedNode.bannedRarity.originalExtensionRaritiesList.includes(ext.rarity);
      } else {
        return this.selectedNode.bannedRarity.replicaExtensionRaritiesList.includes(ext.rarity);
      }
    },
    isReplicaHero: function isReplicaHero(hero) {
      return 11000 < hero.heroType;
    },
    levelSwiperInit: function levelSwiperInit() {
      var _this3 = this;
      this.$nextTick(function () {
        var index = _this3.lvs.findIndex(function (lv) {
          return lv.nodeId === _this3.selectedNodeId;
        });
        _this3.levelSwiper.slideTo(index, 0);
      });
    },
    teamSwiperInit: function teamSwiperInit() {
      var _this4 = this;
      this.$nextTick(function () {
        _this4.teamSwiper.slideTo(_this4.selectedTeam, 0);
      });
    },
    getNodeIdByIndex: function getNodeIdByIndex(index) {
      return this.lvs[index].nodeId;
    },
    getIsTeamDisabled: function getIsTeamDisabled(index) {
      if (index < 3) {
        return false;
      }
      return !this.isPrime;
    },
    getNecessaryStamina: function getNecessaryStamina(nodeId) {
      return this.node.nodeLvsList.find(function (lv) {
        return lv.nodeId === nodeId;
      }).stamina;
    },
    // async goToQuest() {
    //   // await this.fetchMyOwnExtensionIds()
    //   // let extensionIds = [].concat(this.myOwnIds)
    //   // await this.fetchExtensions(extensionIds)
    //   // let extensions = []
    //   // extensions = extensions.concat(extensionIds.map(id => this.getExtension(id)))
    //   // const minVal = this.$constants.REP_SPHERE_MIN_TYPE
    //   // const maxVal = this.$constants.REP_SPHERE_MAX_TYPE
    //   // extensions = extensions.filter(function(a) {
    //   //   return (a.extensionType >= minVal && a.extensionType < maxVal)
    //   // })
    //   // let ingot = await this.$heroesService.getHeroExpItems()
    //   // let ingotCount = 0
    //   // ingot.heroItemsList.forEach(i => { ingotCount += i.balance})
    //   // if (
    //   //   (this.isNormalQuest && extensions.length >= this.$constants.REP_SPHERE_LIMIT) ||
    //   //   (!this.isNormalQuest && ingotCount >= this.$constants.REP_SPHERE_LIMIT)
    //   //   ) {
    //   //   if (!this.isNormalQuest && ingotCount >= this.$constants.REP_SPHERE_LIMIT) this.ingotLimit = true
    //   //   this.isRepSphereLimtModalShow = true
    //   // } else {
    //     this.go()
    //   // }
    // },
    go: function go() {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var nodeId, latestNodeInfo;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return useNodeStore().startQuest({
                nodeId: _this5.selectedNodeId,
                deckNo: _this5.selectedTeam
              });
            case 3:
              _context3.next = 5;
              return useDeckTemplateStore().fetchTemplateAssets(_this5.templates[_this5.selectedTeam], true);
            case 5:
              _this5.$adService.SendToGTM('quest', _this5.selectedNodeId);
              nodeId = Math.floor(_this5.selectedNodeId / 100);
              latestNodeInfo = _this5.prevNodeInfo;
              latestNodeInfo[nodeId] = _this5.selectedNodeId;
              _this5.$localStorage.set('prevNodeInfo', latestNodeInfo);
              _this5.$localStorage.set('prevNodeType', _this5.node);
              _this5.$localStorage.set('prevTemplateNo', _this5.selectedTeam);
              _this5.$emit('after-go', _this5.quest.battleIdsList);
              _this5.selectedNodeId = 0;
              _this5.selectedTeam = 0;
              _this5.fee = 0;
              _context3.next = 23;
              break;
            case 18:
              _context3.prev = 18;
              _context3.t0 = _context3["catch"](0);
              console.error(_context3.t0);
              _this5.$toast.error('Error.');
              if (_context3.t0.message.includes('replica sphere limit')) {
                _this5.ingotLimit = false;
                _this5.isRepSphereLimtModalShow = true;
              } else if (_context3.t0.message.includes('sphere item limit')) {
                _this5.orbLimit = true;
                _this5.isRepSphereLimtModalShow = true;
              } else if (_context3.t0.message.includes('item limit')) {
                _this5.ingotLimit = true;
                _this5.isRepSphereLimtModalShow = true;
              } else if (_context3.t0.message.includes('cannot quest prime node')) {
                _this5.isPrimeErrorModalShown = true;
              }
            case 23:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[0, 18]]);
      }))();
    },
    selectTeamTemplate: function selectTeamTemplate(teamIndex) {
      return this.selectedTeam = teamIndex;
    },
    updateSelectedNodeId: function updateSelectedNodeId() {
      this.selectedNodeId = this.lvs[this.questLevel].nodeId;
    },
    getSelectedNodeLv: function getSelectedNodeLv() {
      return this.lvs[this.questLevel];
    },
    getPartyLv: function getPartyLv(party) {
      var lv = 0;
      if (party) {
        for (var i = 0; i < party.unitsList.length; i++) {
          var hero = this.getHero(party.unitsList[i].heroId);
          if (party.unitsList[i].asset || party.unitsList[i].heroId < 11000 || party.unitsList[i].heroId >= 12000) {
            lv += this.$constants.PARTY_LV_CALCULATE[hero.rarity];
            lv += Math.floor(hero.lv / 5);
          }
        }
      }
      return lv;
    },
    onClickDrppTabOri: function onClickDrppTabOri() {
      this.isShowOriginal = true;
      this.isShowReplica = false;
    },
    onClickDrppTabRep: function onClickDrppTabRep() {
      this.isShowOriginal = false;
      this.isShowReplica = true;
    },
    partyEdit: function partyEdit() {
      this.saveNode();
      if (this.isNormalQuest) {
        this.$router.push(this.localePath({
          path: "/parties",
          query: {
            partyIndex: Number(this.selectedTeam),
            quest: true
          }
        }));
      } else {
        this.$router.push(this.localePath({
          path: "/parties",
          query: {
            partyIndex: Number(this.selectedTeam),
            quest: true,
            land: true
          }
        }));
      }
    },
    saveNode: function saveNode() {
      var nodeId = Math.floor(this.selectedNodeId / 100);
      var latestNodeInfo = this.prevNodeInfo;
      latestNodeInfo[nodeId] = this.selectedNodeId;
      this.$localStorage.set('prevNodeInfo', latestNodeInfo);
      this.$localStorage.set('prevNodeType', this.node);
      this.$localStorage.set('prevTemplateNo', this.selectedTeam);
    },
    recoveryStaminaModalOpen: function recoveryStaminaModalOpen() {
      var _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return useConsumableStore().fetchLimitedMyItems();
            case 2:
              _this6.isRecoveryStaminaModalShown = true;
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    primeErrorModalClose: function primeErrorModalClose() {
      location.reload();
    }
  }
};